export default __webpack_public_path__ + "static/media/pedro-pascal_1.276f391e.jpg";